import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import PropTypes from 'prop-types';
import Impression from './impression';

var ElementImpression = function ElementImpression(props) {
  var impressionProps = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    id: props.id,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    children: props.children,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    eventName: props.eventName,
    eventData: _objectSpread({
      elementImpressionHeader: {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        elementCategory: props.elementCategory,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        elementContent: props.elementContent,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        elementCount: props.elementCount,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        elementDomId: props.elementDomId || props.id,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        elementDomType: props.elementDomType,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        elementName: props.elementName,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        elementPosition: props.elementPosition,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        pageNumber: props.pageNumber,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sectionCategory: props.sectionCategory,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sectionElementCount: props.sectionElementCount,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sectionPosition: props.sectionPosition
      }
    }, props.verticalImpressionData),
    extractImpressionHeader: function extractImpressionHeader(eventData) {
      return eventData.elementImpressionHeader;
    }
  };
  return /*#__PURE__*/React.createElement(Impression, impressionProps);
};

ElementImpression.defaultProps = {
  eventName: 'ELEMENT_IMPRESSION_EVENT',
  verticalImpressionData: {}
};
ElementImpression.propTypes = {
  children: PropTypes.element,
  elementCategory: PropTypes.string,
  elementContent: PropTypes.string,
  elementCount: PropTypes.number,
  elementDomId: PropTypes.number,
  elementDomType: PropTypes.string,
  elementName: PropTypes.string.isRequired,
  elementPosition: PropTypes.number,
  eventName: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pageNumber: PropTypes.number,
  sectionCategory: PropTypes.string,
  sectionElementCount: PropTypes.number,
  sectionPosition: PropTypes.number,
  // Vertical specific tracking data
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  verticalImpressionData: PropTypes.object
};
export default ElementImpression;